import { ThemeOptions, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { ReactNode, useMemo } from 'react';
import { ThemeContext } from '.';
import { ThemeMode } from '../constants';
import { darkTheme } from '../darkTheme';
import { lightTheme } from '../lightTheme';
import { useThemeStore } from '@modules/theme/store/useThemeStore';
import { shallow } from 'zustand/shallow';

interface ThemeProviderOptions {
  children: ReactNode;
}

export default function ThemeProvider({ children }: ThemeProviderOptions) {
  const { mode, setMode } = useThemeStore(
    ({ mode, setMode }) => ({ mode, setMode }),
    shallow,
  );

  const theme: ThemeOptions = useMemo(
    () => (mode === ThemeMode.LIGHT ? lightTheme : darkTheme),
    [mode],
  );

  return (
    <ThemeContext.Provider value={{ mode, setMode }}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
}
